var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeeMgLogoIconNotext04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 80.7V47.3C107.8 42.1 105.1 37.4 100.6 34.8L71.6 18.1C67.1 15.5 61.6 15.5 57.2 18.1L28.3 34.8C23.8 37.4 21.1 42.1 21.1 47.3V80.7C21.1 85.9 23.8 90.6 28.3 93.2L57.2 109.9C61.7 112.5 67.2 112.5 71.6 109.9L100.5 93.2C105 90.6 107.8 85.8 107.8 80.7Z",
    fill: "#F6851F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 40.3H60C58.3 40.3 56.7 41.2 55.8 42.7L51.4 50.4C50.5 51.9 50.5 53.8 51.4 55.3L55.8 63C56.7 64.5 58.3 65.4 60 65.4H68.9C70.6 65.4 72.2 64.5 73.1 63L77.5 55.3C78.4 53.8 78.4 51.9 77.5 50.4L73.1 42.7C72.2 41.2 70.6 40.3 68.9 40.3Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9 67.1H60C58.3 67.1 56.7 68 55.8 69.5L51.4 77.2C50.5 78.7 50.5 80.6 51.4 82.1L55.8 89.8C56.7 91.3 58.3 92.2 60 92.2H68.9C70.6 92.2 72.2 91.3 73.1 89.8L77.5 82.1C78.4 80.6 78.4 78.7 77.5 77.2L73.1 69.5C72.2 68 70.6 67.1 68.9 67.1Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3 65.4L106.7 41.3C106.7 41.3 123.6 26.9 126.5 36.3C129.4 45.8 119.3 66.7 74.3 65.4Z",
    fill: "#FDC20F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3 65.4L21.9 41.3C21.9 41.3 5 26.9 2.1 36.3C-0.8 45.7 9.2 66.7 54.3 65.4Z",
    fill: "#FDC20F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeMgLogoIconNotext04);
export default __webpack_public_path__ + "static/media/beeMG_logo-icon-notext-04.cb56add9e7a9e1853a64f2572006ce80.svg";
export { ForwardRef as ReactComponent };